export enum FinancialReportType {
    complete = 'complete',
    funding = 'funding',
    payouts = 'payouts',
}
